'use client';
import dynamic from 'next/dynamic';
import ImageContent from '@/components/common/image-content';
import TaxiAppServices from '@/components/technologies/taxi-app-services';
import TaxiAppCloneCost from '@/components/common/taxi-app-clone-cost';
import BookingIndustry from '@/components/common/booking-industry';
import WhyChoose from '@/components/common/why-choose';
import ToConclude from '@/components/common/to-conclude';
import MetaTags from '@/components/meta-tag/meta-tag';
import BorderEdge from '@/components/common/border-edge';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="We Believe in Delivering Top-notch iPhone App Development Services for Fortune Clients Across the Globe."
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'taxiapp-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                How Much Does It Cost To Develop A Custom Taxi App Like Uber, Ola, Lyft?
            </TechHeroApp>
            <BookingIndustry />
            <ImageContent
                title="Why is an on-demand taxi booking mobile app preferred over the offline booking?"
                path={'/img/icons/img-ride-hailing.svg'}
                alt="on-demand taxi booking"
                width={560}
                height={478}
                className="bg-white img-fluid"
            >
                <>
                    <p className="fs-md fw-400 mb-5">
                        Some of the common reasons that have significantly attracted customers to prefer online taxi booking over
                        the offline booking are the convenience that taxi booking mobile applications offers, due to which there
                        is a drastic increase in usage of internet and smartphones by people, all over the world. Moreover,
                        real-time information, like pre-estimated ride fare, contact number of the driver, details of the vehicle,
                        tracking the drivers location and more are easily available within an app quickly which attracts more
                        customers toward the online booking option.
                    </p>
                    <p className="fs-md fw-400 mb-5">
                        Several big operators, like Uber, Lyft, Grab, Ola, and more also provide ridesharing alternative (fare
                        gets divided among co-passengers) in their apps in some regions. This facility has captured the rising
                        demand for low taxi fare services, among the customers. To withstand the increasing trend of ridesharing
                        service, local taxi operators have started adopting a similar strategy, and they too are trying to offer
                        ridesharing option in their respective custom on-demand taxi app development.
                    </p>
                    <p className="fs-md fw-400 mb-5">
                        Another major reason why customers do not wish to travel in their car or bike is the problem of parking
                        space. With the growing population in cities, it is becoming challenging for people to park their vehicle
                        when they are out for a ride to the town. Hence, they choose to download a taxi booking app and book a
                        ride instead of their vehicle.
                    </p>
                </>
            </ImageContent>
            <TaxiAppServices title="Add-On Features in Customers App" title2="Add-On Features in Drivers App" />
            <ImageContent
                title="Why Is The Admin Dashboard, Reporting, And Analytics Important?"
                path={'/img/icons/img-report.svg'}
                alt="on-demand taxi booking"
                width={510}
                height={414}
                className="bg-white"
            >
                <>
                    <p className="fs-md fw-400 mb-5">
                        The service providers can have access to a web-based software which can have a responsive mobile and
                        tablet interface. The Admin Dashboard analyses reports and presents the stored database to manage override
                        passengers and drivers’ activities.
                    </p>
                    <p className="fs-md fw-400 mb-5">
                        The dashboard gives a glimpse of the processes that deliver the coordination of drivers and trips and
                        manages all financial issues. Also, it can be integrated into the third-party analytics tool for
                        monitoring marketing activities.
                    </p>
                    <p className="fs-md fw-400 mb-5">
                        Generally, the admin dashboard is needless in the on-demand taxi booking model, however, needed
                        occasionally to evaluate the entire operation closely. It is just like the CPU of your PC, you might not
                        even bother to look at it but it is essential to run the whole procedure.
                    </p>
                </>
            </ImageContent>
            <TaxiAppCloneCost />
            <WhyChoose />
            <ToConclude />
            <BorderEdge color="text-white" bg="bg-blue" />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
